module.exports = __webpack_public_path__ + "static/media/doei_doei.00505414.mp3";